import React from "react";

const MemberCTA = () => {
    return (
        <div className="member-cta">
            <h5>Become a Member?</h5>
            <p>Membership pays for itself in 3 visits!</p>
            <a className="button" href="/visit/membership">Become a Member</a>
        </div>
    )
};

export default MemberCTA;